import React from 'react';
import { Provider, useDispatch } from 'react-redux';
import store from 'store';
import Root from 'Root';
import routes from 'routes';
import { initAuth } from 'actions/auth';

const InitAuthHOC = ({ children }) => {
    const dispatch = useDispatch();
    dispatch(initAuth());

    return children;
};

export const App = () => (
    <Provider store={store}>
        <InitAuthHOC>
            <Root routes={routes} />
        </InitAuthHOC>
    </Provider>
);
